(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelector('[data-collection-sort]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bundle-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  const wrap = document.currentScript.closest('.bundle-picker-wrap') || document;
  const cards = wrap.querySelectorAll('[data-bundle-card]');

  cards.forEach(card => {
    card.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
    });
  });

  const btns = wrap.querySelectorAll('[data-bundle-atc]');
  btns.forEach(btn => {
    const originalLabel = btn.dataset.label || btn.textContent.trim();

    btn.addEventListener('click', async (e) => {
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.textContent = 'Adicionando…';
      btn.disabled = true;

      try {
        if (window.LeepCart && typeof window.LeepCart.add === 'function') {
          await window.LeepCart.add(variantId, 1);
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (!res.ok) throw new Error('Cart error');
          document.dispatchEvent(new CustomEvent('leep:cart:updated'));
        }
        btn.textContent = 'Adicionado ✓';
        setTimeout(() => { btn.textContent = originalLabel; btn.disabled = false; }, 1800);
      } catch (err) {
        console.error(err);
        btn.textContent = originalLabel;
        btn.disabled = false;
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INIT_FLAG = 'reelCardInit';
    var NAV_FLAG = 'reelNavInit';

    function initReelCard(card) {
      if (card.dataset[INIT_FLAG] === 'true') return;
      card.dataset[INIT_FLAG] = 'true';

      const video = card.querySelector('[data-reel-video]');
      if (!video) return;

      const playBtn  = card.querySelector('[data-reel-play]');
      const muteBtn  = card.querySelector('[data-reel-mute]');
      let loaded = false;

      function loadSources() {
        if (loaded) return;
        loaded = true;
        card.querySelectorAll('source[data-src]').forEach(function (s) {
          s.src = s.dataset.src;
        });
        video.load();
      }

      function play() {
        loadSources();
        video.play().then(function () {
          card.classList.add('is-playing');
          card.classList.remove('is-paused');
        }).catch(function () {});
      }

      function pause() {
        video.pause();
        card.classList.remove('is-playing');
        card.classList.add('is-paused');
      }

      function unmute() {
        video.muted = false;
        card.classList.add('is-unmuted');
      }

      function mute() {
        video.muted = true;
        card.classList.remove('is-unmuted');
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.paused ? play() : pause();
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted ? unmute() : mute();
        });
      }

      video.addEventListener('click', function () {
        video.muted ? unmute() : mute();
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play();
          } else {
            pause();
            mute();
          }
        });
      }, { threshold: 0.4 });

      observer.observe(card);
    }

    function initMobileNav(carousel) {
      if (!carousel || carousel.dataset[NAV_FLAG] === 'true') return;

      var track = carousel.querySelector('[data-reel-track]');
      var nav = carousel.querySelector('[data-reel-nav]');
      if (!track || !nav) return;

      var items = carousel.querySelectorAll('[data-reel-item]');
      var dots = nav.querySelectorAll('[data-reel-dot]');
      if (items.length < 2) return;

      carousel.dataset[NAV_FLAG] = 'true';

      var current = 0;
      var scrollTimer = null;

      function setActive(index) {
        var nextIndex = Math.max(0, Math.min(index, items.length - 1));
        dots.forEach(function (dot, i) {
          var active = i === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        current = nextIndex;
      }

      function getActiveIndex() {
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var minDist = Infinity;

        items.forEach(function (item, i) {
          var rect = item.getBoundingClientRect();
          var itemCenter = rect.left + rect.width / 2;
          var dist = Math.abs(itemCenter - center);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });

        return closest;
      }

      function scrollToIndex(index) {
        var item = items[index];
        if (!item) return;
        var target = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        track.scrollTo({
          left: Math.max(0, target),
          behavior: 'smooth'
        });
        setActive(index);
      }

      carousel.addEventListener('click', function (event) {
        if (event.target.closest('[data-reel-prev]')) {
          event.preventDefault();
          scrollToIndex(current - 1);
          return;
        }

        if (event.target.closest('[data-reel-next]')) {
          event.preventDefault();
          scrollToIndex(current + 1);
          return;
        }

        var dot = event.target.closest('[data-reel-dot]');
        if (dot) {
          event.preventDefault();
          var index = parseInt(dot.dataset.index, 10);
          if (!Number.isNaN(index)) scrollToIndex(index);
        }
      });

      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActive(getActiveIndex());
        }, 80);
      }, { passive: true });

      setActive(0);
    }

    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-reel-card]').forEach(initReelCard);
      scope.querySelectorAll('[data-reel-carousel]').forEach(initMobileNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
  const init = () => {
    const el = document.querySelector('[data-testimonials-swiper]');
    if (!el || el.dataset.swiperInit) return;
    if (typeof Swiper === 'undefined') return;

    el.dataset.swiperInit = 'true';
    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      centeredSlides: true,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      breakpoints: {
        768: { slidesPerView: 2.2, centeredSlides: false },
        1024: { slidesPerView: 3, centeredSlides: false },
      },
    });
  };

  const loadSwiper = () => {
    if (typeof Swiper !== 'undefined') {
      init();
      return;
    }
    const link = document.createElement('script');
    link.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    link.onload = init;
    document.head.appendChild(link);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadSwiper);
  } else {
    loadSwiper();
  }
  })();

  } catch(e) { console.error(e); }
})();
})();
